const DownArrowIcon = () => {
  return (
    <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 -5.24537e-07L6 6L12 0" fill="white" />
    </svg>
  );
};

export default DownArrowIcon;
